import { createStore, applyMiddleware  } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import rootReducer from './rootReducer'
import thunk from "redux-thunk"

const store : any = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));

export default store